import { useDismissUserTask } from '@/api/userTasks/mutations'
import { useUserTaskStream } from '@/api/userTasks/useUserTaskStream'
import { useState } from 'react'
import { UserTaskToast } from './UserTaskToast'

export function UserTaskToasts() {
  const tasks = useUserTaskStream()
  const dismiss = useDismissUserTask()
  const [dismissing, setDismissing] = useState<string[]>([])

  if (tasks.length === 0) return null

  const onDismiss = (taskId: string) => {
    setDismissing((ids) => [...ids, taskId])
    dismiss.mutate(
      { params: { query: { task_id: taskId } } },
      {
        onSettled: () =>
          setDismissing((ids) => ids.filter((id) => id !== taskId)),
      },
    )
  }

  return (
    <div
      data-testid='user-task-toasts'
      style={{
        position: 'fixed',
        bottom: 16,
        left: 80,
        width: 320,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 900,
      }}
    >
      {tasks.map((task) => (
        <UserTaskToast
          key={String(task._id)}
          task={task}
          onDismiss={onDismiss}
          dismissing={dismissing.includes(String(task._id))}
        />
      ))}
    </div>
  )
}
